export default "__VITE_ASSET__Iana6slR__"